// extracted by mini-css-extract-plugin
export default {"main":"login_main__n7gVD","innerMain":"login_innerMain__BYGpU","form":"login_form__bia3H","imageContainer":"login_imageContainer__JSwUh"};